(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("galleryPopup");
  const popupImg = document.getElementById("popupImage");
  const closeBtn = document.querySelector(".close-popup");

  document.querySelectorAll(".popup-trigger").forEach(img => {
    img.addEventListener("click", function () {
      popup.style.display = "flex";
      popupImg.src = this.getAttribute("data-full");
    });
  });

  closeBtn.addEventListener("click", () => popup.style.display = "none");

  popup.addEventListener("click", function (e) {
    if (e.target === popup) popup.style.display = "none";
  });
});

  } catch(e) { console.error(e); }
})();
})();
